import { Role } from 'src/app/classes/Role.class';

export const roles: Role[] = [
  { code: 'super_admin', name: 'Admin' },
  { code: 'admin', name: 'Technician' },
  { code: 'staff', name: 'Staff' },
];

const defaultRolesEn: Role[] = [
  { code: 'admin', name: 'Technician' },
  { code: 'staff', name: 'Staff' },
];

const defaultRolesDe: Role[] = [
  { code: 'admin', name: 'Techniker' },
  { code: 'staff', name: 'Staff' },
];

const mowaAdminRolesEn: Role[] = [
  { code: 'super_admin', name: 'Admin' },
  { code: 'admin', name: 'Technician' },
  { code: 'staff', name: 'Staff' },
];

const mowaAdminRolesDe: Role[] = [
  { code: 'super_admin', name: 'Admin' },
  { code: 'admin', name: 'Techniker' },
  { code: 'staff', name: 'Staff' },
];

export function getRoles(val = false, language = 'en'): Role[] {
  console.log(language);
  if (language === 'de') {
    return !val ? defaultRolesDe : mowaAdminRolesDe;
  }
  return !val ? defaultRolesEn : mowaAdminRolesEn;
}
